import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/new/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className='relative p-8 w-full h-screen overflow-y-auto'>
      <Outlet />
    </div>
  );
}
